import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 10,
    fontFamily: 'Helvetica',
    backgroundColor: '#ffffff'
  },

  // ===== HEADER =====
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 24,
    borderBottom: '3px solid #374151',  // ← Abu-abu gelap
    paddingBottom: 16
  },
  headerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12
  },
  logo: {
    width: 50,
    height: 50
  },
  companyName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1f2937'  // ← Abu-abu gelap
  },
  companySub: {
    fontSize: 8,
    color: '#6b7280'
  },
  headerRight: {
    alignItems: 'flex-end'
  },
  invoiceTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#374151',  // ← Abu-abu gelap
    letterSpacing: 2
  },
  invoiceNumber: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#1f2937',
    marginTop: 4
  },
  invoiceDate: {
    fontSize: 9,
    color: '#6b7280'
  },

  // ===== INFO BOX =====
  infoBox: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 20,
    backgroundColor: '#e5e7eb',  // ← Abu-abu sedang
    padding: 12,
    borderRadius: 4
  },
  infoColumn: {
    width: '30%'
  },
  infoLabel: {
    fontSize: 8,
    color: '#4b5563',
    fontWeight: 'bold',
    marginBottom: 2,
    textTransform: 'uppercase'
  },
  infoValue: {
    fontSize: 9,
    color: '#1f2937'
  },

  // ===== SECTION =====
  section: {
    marginBottom: 12
  },
  sectionTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#374151',
    marginBottom: 6,
    textTransform: 'uppercase'
  },

  // ===== ROW =====
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 2
  },
  label: {
    fontSize: 9,
    color: '#6b7280',
    width: '30%'
  },
  value: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#1f2937',
    width: '70%',
    textAlign: 'right'
  },

  // ===== TABLE =====
  table: {
    marginTop: 4
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#4b5563',  // ← Abu-abu gelap
    paddingVertical: 6,
    paddingHorizontal: 8,
    borderRadius: 2
  },
  tableHeaderText: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#ffffff',
    textTransform: 'uppercase'
  },
  tableRow: {
    flexDirection: 'row',
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderBottom: '1px solid #e5e7eb'
  },
  tableRowAlt: {
    backgroundColor: '#f3f4f6'  // ← Abu-abu muda
  },
  colItem: { width: '45%', fontSize: 9, color: '#1f2937' },
  colQty: { width: '15%', fontSize: 9, color: '#1f2937', textAlign: 'center' },
  colPrice: { width: '20%', fontSize: 9, color: '#1f2937', textAlign: 'right' },
  colTotal: { width: '20%', fontSize: 9, fontWeight: 'bold', color: '#1f2937', textAlign: 'right' },

  // ===== TOTAL =====
  totalSection: {
    marginTop: 16,
    paddingTop: 12,
    borderTop: '2px solid #374151',  // ← Abu-abu gelap
    alignItems: 'flex-end'
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 3,
    width: '40%'
  },
  totalLabel: {
    fontSize: 9,
    color: '#6b7280'
  },
  totalValue: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#1f2937'
  },
  grandTotalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 6,
    borderTop: '2px solid #1f2937',
    marginTop: 4,
    width: '40%'
  },
  grandTotalLabel: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#374151'  // ← Abu-abu gelap
  },
  grandTotalValue: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#374151'  // ← Abu-abu gelap
  },

  // ===== SIGNATURE =====
  signatureSection: {
    marginTop: 24,
    paddingTop: 12,
    borderTop: '1px solid #e5e7eb',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  signatureBox: {
    width: '45%',
    alignItems: 'center'
  },
  signatureLine: {
    borderTop: '1px solid #1f2937',
    width: 120,
    marginTop: 16,
    marginBottom: 4
  },
  signatureName: {
    fontSize: 9,
    fontWeight: 'bold',
    color: '#1f2937'
  },
  signatureRole: {
    fontSize: 8,
    color: '#6b7280'
  },

  // ===== FOOTER =====
  footer: {
    marginTop: 20,
    paddingTop: 8,
    borderTop: '1px solid #e5e7eb',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  footerText: {
    fontSize: 7,
    color: '#6b7280'
  },

  // ===== STATUS BADGE =====
  statusBadge: {
    fontSize: 8,
    paddingHorizontal: 10,
    paddingVertical: 3,
    borderRadius: 12,
    marginTop: 4,
    textAlign: 'center'
  }
});

const formatCurrency = (amount) => {
  if (!amount || isNaN(amount)) return 'Rp 0';
  return `Rp ${Math.round(amount).toLocaleString('id-ID')}`;
};

const formatDate = (date) => {
  if (!date) return '-';
  try {
    return new Date(date).toLocaleDateString('id-ID', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  } catch (e) {
    return '-';
  }
};

const InvoicePDF = ({
  wo = {},
  customer = {},
  staff = {},
  transaction = {},
  signature = null,
  companyName = 'AKASIA WORKSHOP',
  companyAddress = 'Jl. Workshop No. 1, Jakarta'
}) => {
  const items = transaction?.items || [];
  const subtotal = transaction?.subtotal || 0;
  const tax = transaction?.tax || 0;
  const total = transaction?.total || 0;
  const taxPercent = transaction?.taxPercent || 0;
  const taxName = transaction?.taxName || 'PPN';
  const discount = transaction?.discount || 0;
  const statusPaid = transaction?.paymentStatus === 'paid' || transaction?.payment_status === 'paid';

  const signerName = wo?.staffName || staff?.name || 'Admin';
  const signerRole = wo?.staffRole || staff?.level || 'Manager';

  return (
    <Document>
      <Page size="A4" style={styles.page}>

        {/* ============================================================
            HEADER
            ============================================================ */}
        <View style={styles.header}>
          <View style={styles.headerLeft}>
            <Image src="/trakhir.png" style={styles.logo} />
            <View>
              <Text style={styles.companyName}>{companyName}</Text>
              <Text style={styles.companySub}>{companyAddress}</Text>
            </View>
          </View>
          <View style={styles.headerRight}>
            <Text style={styles.invoiceTitle}>INVOICE</Text>
            <Text style={styles.invoiceNumber}>{wo?.woNumber || '-'}</Text>
            <Text style={styles.invoiceDate}>{formatDate(transaction?.date || wo?.createdAt)}</Text>
            <Text style={[
              styles.statusBadge,
              { 
                backgroundColor: statusPaid ? '#d1fae5' : '#fef3c7',
                color: statusPaid ? '#065f46' : '#92400e'
              }
            ]}>
              {statusPaid ? 'LUNAS' : 'BELUM BAYAR'}
            </Text>
          </View>
        </View>

        {/* ============================================================
            INFO BOX (Bill To + Ship To + Payment Terms)
            ============================================================ */}
        <View style={styles.infoBox}>
          <View style={styles.infoColumn}>
            <Text style={styles.infoLabel}>BILL TO</Text>
            <Text style={styles.infoValue}>{customer?.name || '-'}</Text>
            <Text style={styles.infoValue}>{customer?.address || '-'}</Text>
            <Text style={styles.infoValue}>{customer?.phone || '-'}</Text>
          </View>
          <View style={styles.infoColumn}>
            <Text style={styles.infoLabel}>SHIP TO</Text>
            <Text style={styles.infoValue}>{customer?.name || '-'}</Text>
            <Text style={styles.infoValue}>{customer?.address || '-'}</Text>
          </View>
          <View style={styles.infoColumn}>
            <Text style={styles.infoLabel}>PAYMENT TERMS</Text>
            <Text style={styles.infoValue}>Transfer Bank</Text>
            <Text style={styles.infoValue}>BCA: 123-456-789</Text>
          </View>
        </View>

        {/* ============================================================
            ITEMS TABLE
            ============================================================ */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Item Description</Text>
          <View style={styles.table}>
            <View style={styles.tableHeader}>
              <Text style={[styles.tableHeaderText, { width: '45%' }]}>DESCRIPTION</Text>
              <Text style={[styles.tableHeaderText, { width: '15%', textAlign: 'center' }]}>QTY</Text>
              <Text style={[styles.tableHeaderText, { width: '20%', textAlign: 'right' }]}>PRICE</Text>
              <Text style={[styles.tableHeaderText, { width: '20%', textAlign: 'right' }]}>AMOUNT</Text>
            </View>

            {items.length > 0 ? (
              items.map((item, i) => (
                <View key={i} style={[styles.tableRow, i % 2 === 0 && styles.tableRowAlt]}>
                  <Text style={styles.colItem}>{item?.name || 'Item'}</Text>
                  <Text style={styles.colQty}>{item?.quantity || 1}</Text>
                  <Text style={styles.colPrice}>{formatCurrency(item?.price || 0)}</Text>
                  <Text style={styles.colTotal}>{formatCurrency(item?.total || 0)}</Text>
                </View>
              ))
            ) : (
              <View style={styles.tableRow}>
                <Text style={styles.colItem}>Tidak ada item</Text>
                <Text style={styles.colQty}>-</Text>
                <Text style={styles.colPrice}>-</Text>
                <Text style={styles.colTotal}>-</Text>
              </View>
            )}
          </View>
        </View>

        {/* ============================================================
            TOTAL
            ============================================================ */}
        <View style={styles.totalSection}>
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>SUB-TOTAL</Text>
            <Text style={styles.totalValue}>{formatCurrency(subtotal)}</Text>
          </View>
          {discount > 0 && (
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>DISCOUNT</Text>
              <Text style={styles.totalValue}>-{formatCurrency(discount)}</Text>
            </View>
          )}
          <View style={styles.totalRow}>
            <Text style={styles.totalLabel}>{taxName} ({taxPercent}%)</Text>
            <Text style={styles.totalValue}>{formatCurrency(tax)}</Text>
          </View>
          <View style={styles.grandTotalRow}>
            <Text style={styles.grandTotalLabel}>TOTAL AMOUNT</Text>
            <Text style={styles.grandTotalValue}>{formatCurrency(total)}</Text>
          </View>
        </View>

        {/* ============================================================
            SIGNATURE
            ============================================================ */}
        <View style={styles.signatureSection}>
          <View style={styles.signatureBox}>
            <Text style={{ fontSize: 8, color: '#666', marginBottom: 4 }}>Penerima</Text>
            <View style={{ height: 30 }} />
            <View style={styles.signatureLine} />
            <Text style={styles.signatureName}></Text>
            <Text style={styles.signatureRole}>Nama & Tanda Tangan</Text>
          </View>

          <View style={styles.signatureBox}>
            <Text style={{ fontSize: 8, color: '#666', marginBottom: 4 }}>Penanggung Jawab</Text>
            {signature ? (
              <Image src={signature} style={{ width: 80, height: 30 }} />
            ) : (
              <View style={{ height: 20 }} />
            )}
            <View style={styles.signatureLine} />
            <Text style={styles.signatureName}>{signerName}</Text>
            <Text style={styles.signatureRole}>{signerRole}</Text>
          </View>
        </View>

        {/* ============================================================
            FOOTER
            ============================================================ */}
        <View style={styles.footer}>
          <Text style={styles.footerText}>
            {companyName} • {new Date().getFullYear()}
          </Text>
          <Text style={styles.footerText}>
            Diterbitkan: {new Date().toLocaleDateString('id-ID')}
          </Text>
        </View>

      </Page>
    </Document>
  );
};

export default InvoicePDF;